export const contentPillars = [
  {
    icon: "ri-live-line",
    title: "直播内容",
    tag: "实时 · 可互动",
    desc: "以实时互动为核心，观众可发弹幕、点歌、参与连线。内容按分区组织，晚间与深夜的热门分区不同，节奏可快可慢。",
    points: ["按分区而非推荐流浏览", "互动决定节目走向", "深夜档独立编排"],
  },
  {
    icon: "ri-play-circle-line",
    title: "短视频内容",
    tag: "碎片 · 可回看",
    desc: "把直播名场面或独立题材剪成短片，按高能剪辑、日常记录、剧情短片、技巧教学等题材分类，适合碎片时间快速扫看。",
    points: ["按题材标签筛选", "单条时长普遍更短", "可反复回看"],
  },
  {
    icon: "ri-gift-line",
    title: "福利内容",
    tag: "权限 · 分时段",
    desc: "福利内容不是独立站点，而是分布在各分区与短视频标签中，按账号权限与时段开放，需要在主站入口按标签查看。",
    points: ["随账号层级显示范围", "深夜时段开放更集中", "页面会给出明确提示"],
  },
];

export const overviewStats = [
  {
    value: "12+",
    label: "直播分区",
    desc: "从娱乐互动到情感陪伴，覆盖晚间与深夜不同时段的主流直播类型。",
    icon: "ri-live-line",
  },
  {
    value: "8 类",
    label: "短视频题材",
    desc: "才艺、日常、剧情、剪辑等分类，按兴趣快速筛选想看的内容。",
    icon: "ri-play-circle-line",
  },
  {
    value: "3 档",
    label: "权限层级",
    desc: "游客、注册用户与 VIP 三档权限，对应不同的清晰度与内容范围。",
    icon: "ri-vip-crown-line",
  },
  {
    value: "深夜档",
    label: "独立编排",
    desc: "22:00 之后平台会切换内容编排节奏，深夜档与日常档差异明显。",
    icon: "ri-moon-clear-line",
  },
];

export const tickerItems = [
  "快猫直播分区导航已更新",
  "短视频「高能剪辑」分类新增合集",
  "深夜档 22:00 起切换内容编排",
  "VIP 权限说明页可直接对照查看",
  "主播风格图谱新增「轻松聊天型」",
  "福利内容观看方式有完整步骤说明",
];

export const liveFilters = [
  { id: "all", label: "全部分区" },
  { id: "ent", label: "娱乐互动" },
  { id: "talent", label: "才艺表演" },
  { id: "life", label: "生活分享" },
  { id: "game", label: "游戏陪玩" },
  { id: "together", label: "情感陪伴" },
];

export const liveZones = [
  {
    id: "talk",
    group: "ent",
    name: "互动聊天区",
    heat: "高峰 00:00",
    icon: "ri-chat-smile-2-line",
    desc: "以弹幕互动为主的分区，主播多为健谈型，话题跟随观众实时变动，适合想找人闲聊、参与话题的观众。",
    bullets: ["弹幕滚动快，话题密度高", "常有连麦环节", "适合碎片时间进入"],
  },
  {
    id: "talent-sing",
    group: "talent",
    name: "唱歌才艺区",
    heat: "高峰 21:00",
    icon: "ri-mic-line",
    desc: "以翻唱、清唱和点歌为主要形式，观众可点歌或送祝福，节奏偏慢，适合当作背景音陪伴。",
    bullets: ["支持点歌与合唱", "音质大多为中高码率", "晚间档节目单较固定"],
  },
  {
    id: "dance",
    group: "talent",
    name: "舞蹈表演区",
    heat: "高峰 22:30",
    icon: "ri-music-2-line",
    desc: "以舞蹈翻跳、编舞展示为主，画面节奏强、镜头变化多，深夜档的编排会更集中。",
    bullets: ["短时高频表演", "常有连番曲目串烧", "画质档位可手动切换"],
  },
  {
    id: "daily",
    group: "life",
    name: "生活日常区",
    heat: "高峰 20:00",
    icon: "ri-home-smile-line",
    desc: "做饭、收纳、通勤、撸猫等生活流内容，气氛松弛，互动以陪伴式闲聊为主，适合放松浏览。",
    bullets: ["节奏舒缓无压力", "内容跟随真实日常", "回放留存时间较长"],
  },
  {
    id: "outdoor",
    group: "life",
    name: "户外走播区",
    heat: "高峰 19:30",
    icon: "ri-roadster-line",
    desc: "主播边走边播，画面以街景、夜市、探店为主，随机性强，适合喜欢看新鲜场景的观众。",
    bullets: ["场景随机、临场感强", "受网络波动影响较大", "常与弹幕实时选路"],
  },
  {
    id: "game",
    group: "game",
    name: "游戏陪玩区",
    heat: "高峰 23:00",
    icon: "ri-gamepad-line",
    desc: "以陪玩、组队、看主播打游戏为主，互动围绕对局展开，观众可参与排位或发指令。",
    bullets: ["对局内容实时推进", "支持组队与观战", "深夜档气氛更放松"],
  },
  {
    id: "emotion",
    group: "together",
    name: "情感陪伴区",
    heat: "高峰 01:00",
    icon: "ri-heart-3-line",
    desc: "以陪聊、晚安电台、情感树洞为形式，语速慢、音量低，深夜档开放时间普遍更晚。",
    bullets: ["偏语音与电台形式", "深夜时段活跃度最高", "适合睡前收听"],
  },
  {
    id: "asmr",
    group: "together",
    name: "轻音陪伴区",
    heat: "高峰 00:30",
    icon: "ri-headphone-line",
    desc: "以轻音乐、白噪音、朗读为主，几乎不强调视觉画面，主打听觉陪伴，适合工作或睡前播放。",
    bullets: ["听觉优先、画面简洁", "内容重复度低但不喧闹", "可后台持续播放"],
  },
  {
    id: "variety",
    group: "ent",
    name: "整活综艺区",
    heat: "高峰 21:30",
    icon: "ri-emotion-laugh-line",
    desc: "以连线游戏、惩罚挑战、趣味整活为主，节目感强、笑点密集，多为多人联动形式。",
    bullets: ["多人联动、节奏明快", "常有固定节目单", "观众可参与投票决定玩法"],
  },
  {
    id: "talent-instrument",
    group: "talent",
    name: "乐器演奏区",
    heat: "高峰 20:30",
    icon: "ri-album-line",
    desc: "钢琴、吉他、古筝等乐器演奏为主，节目偏安静，适合喜欢纯演奏、不看花活的观众。",
    bullets: ["演奏完整度高", "曲目可选范围广", "噪音低、适合长时间播放"],
  },
];

export const streamerStyles = [
  {
    id: "s1",
    name: "健谈话题型",
    tag: "互动聊天区",
    signature: "话题更新快，善于接住弹幕梗，几乎不冷场。",
    bestFor: "想找人聊天、参与实时话题的观众",
    rhythm: "高频互动 · 弹幕密集",
    image: "https://readdy.ai/api/search-image?query=abstract%20portrait%20silhouette%20of%20a%20talkative%20streamer%20lit%20by%20warm%20coral%20and%20amber%20neon%20glow%2C%20dark%20cinematic%20studio%20atmosphere%2C%20soft%20haze%20and%20glowing%20bokeh%2C%20stylized%20editorial%20poster%2C%20no%20text&width=600&height=760&seq=km-streamer-talk-01&orientation=portrait",
  },
  {
    id: "s2",
    name: "舞台表演型",
    tag: "唱歌 / 舞蹈区",
    signature: "以完整表演为主，运镜讲究，节目单提前排好。",
    bestFor: "想看高质量才艺表演的观众",
    rhythm: "节目感强 · 节奏明快",
    image: "https://readdy.ai/api/search-image?query=abstract%20stage%20performer%20silhouette%20under%20warm%20coral%20and%20golden%20amber%20spotlights%2C%20dark%20theatrical%20backdrop%2C%20soft%20haze%20and%20light%20streaks%2C%20stylized%20cinematic%20poster%2C%20no%20text&width=600&height=760&seq=km-streamer-stage-02&orientation=portrait",
  },
  {
    id: "s3",
    name: "陪伴日常型",
    tag: "生活分享区",
    signature: "边做自己的事边闲聊，气氛松弛不紧绷。",
    bestFor: "喜欢陪伴感、当作背景音的观众",
    rhythm: "慢节奏 · 低压力",
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20living%20room%20scene%20lit%20by%20amber%20lamp%20light%20with%20coral%20accents%2C%20abstract%20stylized%20editorial%20photography%2C%20soft%20haze%2C%20inviting%20calm%20mood%2C%20no%20people%20no%20text&width=600&height=760&seq=km-streamer-daily-03&orientation=portrait",
  },
  {
    id: "s4",
    name: "技术竞技型",
    tag: "游戏陪玩区",
    signature: "以对局操作为主，边打边解说，常有高光操作。",
    bestFor: "想看技术、想组队参与的观众",
    rhythm: "实时对局 · 强参与",
    image: "https://readdy.ai/api/search-image?query=abstract%20esports%20setup%20with%20glowing%20coral%20and%20amber%20keyboard%20lights%20in%20a%20dark%20room%2C%20stylized%20cinematic%20tech%20mood%2C%20soft%20haze%20and%20bokeh%2C%20no%20people%20no%20text&width=600&height=760&seq=km-streamer-game-04&orientation=portrait",
  },
  {
    id: "s5",
    name: "深夜电台型",
    tag: "情感 / 轻音区",
    signature: "低声线、慢语速，以晚安电台和树洞为主。",
    bestFor: "睡前收听、需要安静陪伴的观众",
    rhythm: "深夜档 · 听觉优先",
    image: "https://readdy.ai/api/search-image?query=abstract%20vintage%20radio%20microphone%20in%20deep%20shadow%20with%20a%20warm%20coral%20and%20amber%20glow%2C%20midnight%20quiet%20mood%2C%20stylized%20cinematic%20still%20life%2C%20soft%20haze%2C%20no%20text&width=600&height=760&seq=km-streamer-night-05&orientation=portrait",
  },
  {
    id: "s6",
    name: "整活综艺型",
    tag: "整活综艺区",
    signature: "多人联动、玩法多变，笑点密集节目感强。",
    bestFor: "想看轻松搞笑、参与互动的观众",
    rhythm: "多人联动 · 笑点密集",
    image: "https://readdy.ai/api/search-image?query=abstract%20playful%20stage%20set%20with%20colorful%20coral%20amber%20and%20teal%20party%20lights%20on%20a%20dark%20background%2C%20stylized%20fun%20editorial%20poster%2C%20soft%20haze%2C%20no%20people%20no%20text&width=600&height=760&seq=km-streamer-variety-06&orientation=portrait",
  },
];

export const shortVideoFilters = [
  { id: "all", label: "全部题材" },
  { id: "clip", label: "高能剪辑" },
  { id: "daily", label: "日常记录" },
  { id: "story", label: "剧情短片" },
  { id: "tutorial", label: "技巧教学" },
];

export const shortVideoCategories = [
  {
    id: "v1",
    group: "clip",
    title: "高能剪辑",
    count: "每条约 15–45 秒",
    desc: "把直播中的名场面、反差点和连番操作剪成短片段，节奏快、信息量大，适合快速扫看。",
    tags: ["名场面", "反差梗", "连番串烧"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20fast%20motion%20light%20trails%20in%20coral%20and%20amber%20on%20a%20dark%20background%2C%20energetic%20stylized%20cover%20art%2C%20soft%20glow%20and%20haze%2C%20no%20text&width=480&height=640&seq=km-video-clip-01&orientation=portrait",
  },
  {
    id: "v2",
    group: "daily",
    title: "日常记录",
    count: "每条约 30–90 秒",
    desc: "主播生活里的小片段，做饭、养宠、通勤随手记录，画面朴素但真实，适合当作背景刷看。",
    tags: ["vlog", "宠物日常", "随手拍"],
    cover: "https://readdy.ai/api/search-image?query=cozy%20warm%20morning%20window%20light%20with%20amber%20tones%20and%20coral%20accents%2C%20abstract%20stylized%20vlog%20cover%2C%20soft%20haze%2C%20calm%20mood%2C%20no%20people%20no%20text&width=480&height=640&seq=km-video-daily-02&orientation=portrait",
  },
  {
    id: "v3",
    group: "story",
    title: "剧情短片",
    count: "每条约 1–3 分钟",
    desc: "一人分饰多角或小组出演的短剧，情节完整、有反转，适合想一口气看完小故事的观众。",
    tags: ["一人多角", "反转", "短剧合集"],
    cover: "https://readdy.ai/api/search-image?query=dramatic%20abstract%20theatrical%20curtain%20scene%20in%20coral%20amber%20and%20teal%20tones%2C%20stylized%20cinematic%20cover%20art%2C%20soft%20haze%20and%20glow%2C%20no%20people%20no%20text&width=480&height=640&seq=km-video-story-03&orientation=portrait",
  },
  {
    id: "v4",
    group: "tutorial",
    title: "技巧教学",
    count: "每条约 40–120 秒",
    desc: "化妆、剪辑、游戏技巧、乐器入门等实用内容，步骤清晰，适合边看边跟着做。",
    tags: ["入门教程", "分步演示", "干货合集"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20desk%20flat%20lay%20with%20amber%20and%20coral%20stationery%20and%20a%20glowing%20screen%2C%20stylized%20tutorial%20cover%20art%2C%20soft%20haze%2C%20no%20text&width=480&height=640&seq=km-video-tutorial-04&orientation=portrait",
  },
  {
    id: "v5",
    group: "clip",
    title: "弹幕合辑",
    count: "每条约 20–60 秒",
    desc: "把同一主题下的弹幕名场面串成合集，笑点来自观众互动本身，适合一起刷过的老观众。",
    tags: ["弹幕梗", "合集", "老粉向"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20floating%20glowing%20message%20bubbles%20in%20coral%20amber%20and%20teal%20on%20a%20dark%20background%2C%20stylized%20digital%20cover%20art%2C%20soft%20glow%2C%20no%20text&width=480&height=640&seq=km-video-danmu-05&orientation=portrait",
  },
  {
    id: "v6",
    group: "story",
    title: "深夜独白",
    count: "每条约 1–2 分钟",
    desc: "以旁白和氛围画面为主的情绪向短片，画面安静、文字慢，适合睡前慢慢看。",
    tags: ["氛围向", "旁白", "睡前看"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20midnight%20window%20with%20rain%20and%20a%20warm%20coral%20amber%20lamp%20glow%2C%20quiet%20cinematic%20mood%2C%20stylized%20cover%20art%2C%20soft%20haze%2C%20no%20text&width=480&height=640&seq=km-video-night-06&orientation=portrait",
  },
];

export const welfareSteps = [
  {
    step: "01",
    title: "先确认账号权限",
    desc: "福利内容按账号层级开放。登录后进入「我的」页面即可查看当前属于游客、注册用户还是 VIP，权限不同能看到的内容范围也不同。",
  },
  {
    step: "02",
    title: "在主站分区入口浏览",
    desc: "福利内容并不会单独成站，而是分散在各分区里。直播分区页与短视频页都设有对应标签，按标签筛选比盲目刷更省时间。",
  },
  {
    step: "03",
    title: "关注主播获取更新",
    desc: "关注后可在「关注」列表中集中查看动态，避免每次重新搜索。主播开播、发布新短视频时会显示更新标记。",
  },
  {
    step: "04",
    title: "按提示完成观看条件",
    desc: "部分内容需要满足观看条件（如等级、时长或指定权限）后才会显示入口。页面会给出明确提示，按提示操作即可，不必反复重试。",
  },
  {
    step: "05",
    title: "留意时段与公告",
    desc: "深夜档内容在固定时段开放，平台也会通过站内公告说明调整。关注公告可以第一时间知道开放时间和范围变化。",
  },
];

export const vipTiers = [
  { label: "游客", sub: "免登录", tone: "neutral" },
  { label: "注册用户", sub: "免费注册", tone: "secondary" },
  { label: "VIP", sub: "订阅制", tone: "primary" },
];

export const vipComparison = [
  { feature: "浏览直播分区与短视频", guest: "支持", member: "支持", vip: "支持", highlight: false },
  { feature: "发送弹幕与评论", guest: "受限", member: "支持", vip: "支持", highlight: false },
  { feature: "关注主播、收藏内容", guest: "不支持", member: "支持", vip: "支持", highlight: false },
  { feature: "观看回放与历史记录", guest: "不支持", member: "部分支持", vip: "支持", highlight: false },
  { feature: "手动切换清晰度", guest: "固定低清", member: "标准档", vip: "高清档", highlight: true },
  { feature: "深夜档内容范围", guest: "不开放", member: "基础范围", vip: "完整范围", highlight: true },
  { feature: "专属标识与优先通道", guest: "无", member: "无", vip: "有", highlight: true },
  { feature: "弹幕样式与个性装扮", guest: "默认", member: "基础款", vip: "全部解锁", highlight: false },
];

export const nightSlots = [
  {
    time: "22:00",
    title: "编排切换",
    desc: "平台进入深夜节奏，娱乐互动与整活综艺类内容密度上升，聊天区热度明显提高。",
    featured: false,
  },
  {
    time: "23:00",
    title: "陪玩与联动高峰",
    desc: "游戏陪玩、多人联动节目集中开播，观众参与度最高，弹幕与订单都进入峰值。",
    featured: false,
  },
  {
    time: "00:30",
    title: "轻音陪伴档",
    desc: "轻音乐、白噪音与朗读类内容增多，画面趋于简洁，主打听觉陪伴。",
    featured: true,
  },
  {
    time: "01:00",
    title: "情感电台档",
    desc: "陪聊、晚安电台、情感树洞成为主力，语速放慢，开放时长普遍延后至更晚。",
    featured: true,
  },
  {
    time: "03:00",
    title: "深夜专属范围",
    desc: "这一时段的部分内容仅对 VIP 开放完整范围，注册用户与游客可见范围相对有限。",
    featured: true,
  },
];

export const efficiencyTips = [
  {
    icon: "ri-bookmark-3-line",
    title: "先关注再回看",
    desc: "看到喜欢的主播立刻关注，之后直接从「关注」列表进入，省去每次重新搜索分区的时间。",
  },
  {
    icon: "ri-equalizer-line",
    title: "按需调清晰度",
    desc: "网络不稳时先降到标准档保证流畅，等稳定后再切高清，比一直卡顿重载更省流量。",
  },
  {
    icon: "ri-fingerprint-line",
    title: "用标签代替盲刷",
    desc: "短视频页按题材标签筛选，直播页按分区切换，比在推荐流里无限下滑更快命中想看的内容。",
  },
  {
    icon: "ri-notification-3-line",
    title: "开启开播提醒",
    desc: "对常看的主播开启提醒，只在真正想看时收到通知，避免被无关推送打断。",
  },
  {
    icon: "ri-history-line",
    title: "善用观看记录",
    desc: "记不清上次看到哪，直接翻观看记录。注册用户及以上可查看，进度会自动标记。",
  },
  {
    icon: "ri-moon-line",
    title: "深夜档设好时段",
    desc: "深夜档内容集中在固定时间，提前规划想看的分区，避免在低活跃时段空刷。",
  },
];

export const faqs = [
  {
    q: "快猫的直播分区是怎样划分的？",
    a: "平台按内容形态把直播分为娱乐互动、才艺表演、生活分享、游戏陪玩、情感陪伴等大类，每类下再细分具体分区。分区会随活跃度调整，晚间与深夜的热门分区并不完全相同。",
  },
  {
    q: "短视频和直播的内容会重复吗？",
    a: "不会完全重复。短视频多为直播内容的二次剪辑，或主播单独拍摄的独立题材，分为高能剪辑、日常记录、剧情短片、技巧教学等类别，观看节奏比直播更快。",
  },
  {
    q: "VIP 和注册用户的主要差别在哪？",
    a: "主要差别在清晰度档位、回放范围、深夜档内容范围以及专属标识等方面。基础浏览功能注册用户即可使用，VIP 更多是把范围与画质的上限打开。",
  },
  {
    q: "深夜档为什么和白天不一样？",
    a: "深夜档是独立的内容编排。22:00 之后平台会调整分区热度分布，情感陪伴、轻音陪伴类内容占比上升，部分内容范围仅对更高权限开放。",
  },
  {
    q: "福利内容要不要单独下载 App？",
    a: "福利内容并非独立站点，而是分布在各分区与短视频标签中，按账号权限显示。通过主站入口按标签浏览即可，无需额外安装。",
  },
  {
    q: "找不到想看的内容怎么办？",
    a: "可以先用「关注」列表和观看记录缩小范围，再按题材标签筛选。若内容确实未开放，页面会给出权限或时段提示，按提示确认账号层级或稍后时段再来查看。",
  },
];

export const navLinks = [
  { id: "overview", label: "平台速览" },
  { id: "live", label: "直播分区" },
  { id: "streamers", label: "主播风格" },
  { id: "video", label: "短视频" },
  { id: "welfare", label: "福利观看" },
  { id: "vip", label: "VIP 权限" },
  { id: "night", label: "深夜档" },
  { id: "tips", label: "效率指南" },
  { id: "faq", label: "常见问题" },
];